import { z } from 'zod';

/** Превью одного участника — используется в событиях и местах. */
export const AttendeePreviewDto = z.object({
  userId: z.uuid(),
  displayName: z.string(),
  photoUrl: z.string().nullable(),
  /** true — зритель связан с участником: взаимный, односторонний лайк или пересечение на фото. */
  isConnection: z.boolean().default(false),
});
export type AttendeePreviewDto = z.infer<typeof AttendeePreviewDto>;
